export enum Identification {
  CEDULA = "Cédula",
  PASAPORTE = "Pasaporte",
  RNC = "RNC",
}

export const IdentificationOptions = [
  { label: "Cédula", value: Identification.CEDULA, code: "D" },
  { label: "Pasaporte", value: Identification.PASAPORTE, code: "E" },
  { label: "RNC", value: Identification.RNC, code: "J" },
];
